import { FieldEditorProps } from "../fieldRenderersEditors";
import { categoricalColorSchemes } from "@nivo/colors";
import { DropdownItemProps, Select, StrictSelectProps } from "semantic-ui-react";
import { FieldEditor, ScriptableUiFieldEditor } from "./FieldEditor";
import { ScriptableUiHighlightWrapper, WithHW } from "@famiprog-foundation/scriptable-ui";

export class PieCountColorPaletteFieldEditor extends FieldEditor<string, FieldEditorProps & Partial<StrictSelectProps>> {
    private renderContent(value: string) {
        if (!value || value.length === 0) {
            return <></>;
        }
        const schema: string[] = (categoricalColorSchemes as any)[value as any];
        return <div className="flex-container-row">
            <div className="SelectNivoColor_Text">{value}</div>
            <div>{schema.map(color => <div className="SelectNivoColor_ColorBlock" style={{backgroundColor: color}} />)}</div>
        </div>;
    }

    protected renderEditorComponent(s: WithHW<ScriptableUiFieldEditor.Main>, hw: ScriptableUiHighlightWrapper) {
        const value = this.getValue();
        const options = Object.keys(categoricalColorSchemes).map((s, index) => {
            return {key: index, value: s, text: s, content: this.renderContent(s)} as DropdownItemProps;
        });
        return <Select options={options} clearable value={value} onChange={(e, data) => s.setFieldValue(hw, data.value)}
            trigger={<div style={{marginLeft: "1px"}}>{this.renderContent(value)}</div>} {...this.getPropsToForward()} />;
    }
}

export default PieCountColorPaletteFieldEditor;